import React, { createContext, useContext, useState } from 'react';
import dayjs from 'dayjs';
import useFetchWikiData from '../hooks/useFetchWikiData';

const DashboardContext = createContext();

export const DashboardProvider = ({ children }) => {
  const [selectedArticles, setSelectedArticles] = useState([]);
  const [startDate, setStartDate] = useState(dayjs().subtract(700, 'day').startOf('day')); 
  const [endDate, setEndDate] = useState(dayjs().subtract(1, 'day').endOf('day')); // ✅ Yesterday  
  const [frequency, setFrequency] = useState('weekly'); // 'daily' | 'weekly' | 'monthly'

  const { data } = useFetchWikiData(selectedArticles, startDate, endDate, frequency);

  return (
    <DashboardContext.Provider
      value={{
        selectedArticles,
        setSelectedArticles,
        startDate,
        setStartDate,
        endDate,
        setEndDate,
        frequency,
        setFrequency,
        data,
      }}
    >
      {children}
    </DashboardContext.Provider>
  );
};

export const useDashboard = () => useContext(DashboardContext);
